import { z } from 'zod';
import { documentSchema } from './document';

const createOption = (label: string, value?: string | undefined) => ({
  label,
  value: value ?? label.toLowerCase().replaceAll(' ', '-')
});

export const OPTIONS_PROVINCES = [
  createOption('Ontario'),
  createOption('Quebec'),
  createOption('Nova Scotia'),
  createOption('New Brunswick'),
  createOption('Manitoba'),
  createOption('British Columbia'),
  createOption('Prince Edward Island'),
  createOption('Saskatchewan'),
  createOption('Alberta'),
  createOption('Newfoundland and Labrador'),
  createOption('Northwest Territories'),
  createOption('Yukon'),
  createOption('Nunavut')
];

export const paymentConfigSchema = z.object({
  amount: z.number(),
  currency: z.enum(['CAD', 'USD']),
  description: z.string().nullish(),
  enabled: z.boolean()
});

export const clinicInfoSchema = documentSchema.merge(
  z.object({
    id: z.string(),
    name: z.string(),
    country: z.enum(['canada', 'usa']).optional(),
    // TODO: Fix missing types in provinceOrState
    provinceOrState: z
      .enum(OPTIONS_PROVINCES.map(_ => _.value) as any)
      .optional(),
    city: z.string().optional(),
    address: z.string().optional(),
    postalOrZipCode: z.string().optional(),
    phoneNumber: z.string().optional(),
    faxNumber: z.string().optional(),
    paymentConfig: z.object({
      assessment: paymentConfigSchema
    }),
    crx_settings: z.object({
      FEATURE_FLAGS: z.object({
        ASSESSMENT_BASELINE: z.boolean()
      }),
      patientHome: z
        .object({
          /**
           * 2025-12-22 The ability to disable the visual display of the "activate assessment in clinic" option on the Patient Home page
           */
          shouldShowClinicAdminText: z.boolean()
        })
        .optional()
    })
  })
);

export interface Clinic extends z.infer<typeof clinicInfoSchema> {}
